import { GeoPoint } from 'firebase/firestore';
import { atom } from 'recoil';
import {
  PLATFORM_CONTACT_ADDRESS,
  PLATFORM_CONTACT_NUMBER,
  PLATFORM_FULL_NAME,
  PLATFORM_NAME,
  PLATFORM_NAME_EN,
  PLATFORM_TAX_NUMBER,
} from '~/constants/Info';
import { OrderType, SocialMedia } from '~/types/common';
import { PlatformForCustomerWithId } from '~/types/platform/platform';
import { emptyOperatingTime } from '~/types/utilities';

const platform = atom<PlatformForCustomerWithId>({
  key: 'platform',
  default: {
    id: '',
    platformSetting: {
      allowContainers: false,
      allowMultiStore: false,
      allowItemTags: false,
      allowOrderTypes: [],
      deliveryPartnerPriority: [],
    },
    preOrderSetting: {
      afterHours: 0,
      beforeHours: 72,
      schedule: emptyOperatingTime,
    },
    paymentTypes: [],
    placeOrderCostLimit: {
      [OrderType.STORE_PICKUP]: 0,
      [OrderType.STORE_DELIVERY]: 0,
      [OrderType.STORE_PREORDER_PICKUP]: 0,
      [OrderType.STORE_PREORDER_DELIVERY]: 0,
      [OrderType.PLATFORM_PICKUP]: 0,
      [OrderType.PLATFORM_DELIVERY]: 0,
      [OrderType.PLATFORM_PICKUP_POINT]: 0,
      [OrderType.PLATFORM_PREORDER_PICKUP]: 0,
      [OrderType.PLATFORM_PREORDER_DELIVERY]: 0,
    },
    containers: [],
    name: '',
    banners: [],
    bannerCarouselSeconds: 1,
    logo: '',
    description: '',
    phoneNumber: '',
    tags: [],
    location: {
      address: '',
      geoPoint: new GeoPoint(0, 0),
    },
    currency: 'TWD',
    socialLink: {
      [SocialMedia.FB]: null,
      [SocialMedia.IG]: null,
      [SocialMedia.LINE]: null,
    },
    stores: [],
    displayStores: [],
    remotePickMealPoints: [],
    returnContainerPoints: [],
    operatingTime: emptyOperatingTime,
    pinnedItems: [],
    contactInfo: {
      PLATFORM_NAME_EN,
      PLATFORM_NAME,
      PLATFORM_CONTACT_ADDRESS,
      PLATFORM_CONTACT_NUMBER,
      PLATFORM_FULL_NAME,
      PLATFORM_TAX_NUMBER,
    },
  },
});

export default platform;
